var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGalleryArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 58,
    viewBox: "0 0 52 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 52,
    height: 58,
    rx: 6,
    fill: "#445162",
    fillOpacity: 0.8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.3818 15.2861C18.1375 14.6422 19.352 14.633 20.1035 15.2871H20.1025L34.2881 27.5059V27.5L34.6191 27.7842C35.3935 28.4512 35.3946 29.5463 34.6182 30.208L20.1025 42.7109C19.3457 43.3627 18.1305 43.3635 17.3799 42.71C16.6157 42.0443 16.6042 40.9508 17.3809 40.2881L30.4873 28.998L17.3809 17.709C16.6068 17.0419 16.6055 15.9477 17.3818 15.2861Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGalleryArrowRight);
export default __webpack_public_path__ + "static/media/gallery-arrow-right.069f534d0df1dcd1cc3a18661c46d950.svg";
export { ForwardRef as ReactComponent };